import axios from 'axios'
import ActionsLogin from './LoginActions'

const config = {
  headers: {
    Authorization: 'Bearer ' + ActionsLogin.getToken()
  }
}

const cadastrarMotivoServico = ({
  descricao,
  observacao,
  idc_status,
  idc_instalacao
}) => {
  return axios.post(
    process.env.URL_API_BASE + '/servico-motivo',
    {
      descricao: descricao,
      observacao: observacao,
      idc_status: idc_status,
      created_by: ActionsLogin.getUsuario().cd_usuario
    },
    config
  )
}

const alterarMotivoServico = ({
  id,
  descricao,
  observacao,
  idc_status,
  idc_instalacao
}) => {
  return axios.patch(
    process.env.URL_API_BASE + '/servico-motivo/' + id,
    {
      descricao: descricao,
      observacao: observacao,
      idc_status: idc_status,
      updated_by: ActionsLogin.getUsuario().cd_usuario
    },
    config
  )
}

const listarMotivoServico = async () => {
  let response = await axios.get(
    process.env.URL_API_BASE + '/servico-motivo',
    config
  )
  return response.data
}

export const obterMotivoServico = async id => {
  let response = await axios.get(
    process.env.URL_API_BASE + '/servico-motivo/' + id,
    config
  )
  return response.data
}

const listarMotivoServicosAtivos = async () => {
  let response = await axios.get(
    process.env.URL_API_BASE + '/servico-motivo/listar-ativos',
    config
  )
  return response.data
}

export default {
  cadastrarMotivoServico,
  alterarMotivoServico,
  listarMotivoServico,
  obterMotivoServico,
  listarMotivoServicosAtivos
}



// WEBPACK FOOTER //
// ./src/actions/ServicoMotivoActions.js